import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'chart-common',
  template: ``
})

export class ChartCommon {
  title = input<string>();
  subtitle = input<string>();
}
